// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"414":"9a9a459f","453":"34c5bf2c"}[chunkId] + ".chunk.js";
};